import { roles } from '@/config/roles'

const routes = [
  {
    path: '/administration/users-list',
    name: 'AdministrationUsers',
    component: () => import('@/views/admin/users/Users.vue'),
    meta: {
      roles: [roles.admin]
    }
  },
  {
    path: '/administration/student/list',
    name: 'AdministrationStudents',
    component: () => import('@/views/admin/users/Students.vue'),
    meta: {
      roles: [roles.admin]
    }
  },
  {
    path: '/logs/server',
    name: 'AdministrationServerLogs',
    component: () => import('@/views/admin/logs/Server.vue'),
    meta: {
      roles: [roles.admin]
    }
  },
  {
    path: '/logs/activity',
    name: 'AdministrationActivityLogs',
    component: () => import('@/views/admin/logs/Activity.vue'),
    meta: {
      roles: [roles.admin]
    }
  },
  {
    path: '/logs/students',
    name: 'AdministrationStudentsLogs',
    component: () => import('@/views/admin/logs/StudentsHistory.vue'),
    meta: {
      roles: [roles.admin]
    }
  },
  {
    path: '/administration/classes',
    name: 'AdministrationClasses',
    component: () => import('@/views/admin/organizations/Classes.vue'),
    meta: {
      roles: [roles.admin]
    }
  },
  {
    path: '/administration/universities',
    name: 'AdministrationUniversities',
    component: () => import('@/views/admin/organizations/Universities.vue'),
    meta: {
      roles: [roles.admin]
    }
  },
  {
    path: '/administration/subdivisions',
    name: 'AdministrationSubdivisions',
    component: () => import('@/views/admin/organizations/Subdivisions.vue'),
    meta: {
      roles: [roles.admin]
    }
  },
  {
    path: '/administration/config',
    name: 'AdministrationConfig',
    component: () => import('@/views/admin/Config.vue'),
    meta: {
      roles: [roles.admin]
    }
  },
  {
    path: '/administration/gallery',
    name: 'AdministrationGallery',
    component: () => import('@/views/admin/Gallery.vue'),
    meta: {
      roles: [roles.admin]
    }
  },
  {
    path: '/administration/recommendation/exams',
    name: 'AdministrationExams',
    component: () => import('@/views/admin/recommendations/Exams.vue'),
    meta: {
      roles: [roles.admin]
    }
  },
  {
    path: '/administration/recommendation/dir-groups',
    name: 'AdministrationDirectionGroups',
    component: () => import('@/views/admin/recommendations/DirectionGroups.vue'),
    meta: {
      roles: [roles.admin]
    }
  },
  {
    path: '/administration/recommendation/directions',
    name: 'AdministrationDirections',
    component: () => import('@/views/admin/recommendations/Directions.vue'),
    meta: {
      roles: [roles.admin]
    }
  },
  {
    path: '/administration/recommendation/dir-university',
    name: 'AdministrationDirectionsUniversity',
    component: () => import('@/views/admin/recommendations/DirectionsUniversity.vue'),
    meta: {
      roles: [roles.admin, roles.content, roles.curator]
    }
  },
  {
    path: '/administration/recommendation/professions',
    name: 'AdministrationProfessions',
    component: () => import('@/views/admin/recommendations/Professions.vue'),
    meta: {
      roles: [roles.admin, roles.content, roles.curator]
    }
  },
  {
    path: '/administration/recommendation/professions-interested',
    name: 'ProfessionInterested',
    component: () => import('@/views/admin/recommendations/ProfessionInterested.vue'),
    meta: {
      roles: [roles.admin, roles.content, roles.curator]
    }
  },
]
export default routes
